export const controlMaxWidthStyle = {
    maxWidth: '300px'
};

export const errorMessageStyle = {
    padding: '0',
    marginBottom: '5px',
    background: 'none',
    border: 'none',
    boxShadow: 'none'
};

export const logOutLinkStyle = {
    top: '-50px',
    position: 'relative',
    fontSize: 'small'
};

export const controlButtonStyle = {
    padding: '4px 8px',
    fontSize: 'x-small'
};


// WEBPACK FOOTER //
// ./src/styles.js